import { Component } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { HrefDirective } from '@tdwb/core';
import { ModalNotificationImageDirective } from '../../image/modal-notification-image.directive';

@Component({
  imports: [
    TranslateDirective,
    TranslatePipe,
    HrefDirective,
    ModalNotificationImageDirective
  ],
  selector: 'td-wb-modal-notification-recurring-investments',
  templateUrl: 'modal-notification-recurring-investments.component.html',
  styleUrls: [
    '../modal-notification-common.component.scss',
    'modal-notification-recurring-investments.component.scss'
  ]
})
export class ModalNotificationRecurringInvestmentsComponent {
}
